import { render, staticRenderFns } from "./BarScrollStaff.vue?vue&type=template&id=95d8ffb0&scoped=true&"
import script from "./BarScrollStaff.vue?vue&type=script&lang=js&"
export * from "./BarScrollStaff.vue?vue&type=script&lang=js&"
import style0 from "./BarScrollStaff.vue?vue&type=style&index=0&id=95d8ffb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d8ffb0",
  null
  
)

export default component.exports